import { render, staticRenderFns } from "./IncidentInfoTypeCard.vue?vue&type=template&id=91c64022&"
import script from "./IncidentInfoTypeCard.vue?vue&type=script&lang=js&"
export * from "./IncidentInfoTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports